import * as types from './types';

export const setAdminAuditLogsLoading = (isLoading = false) => ({
  type: types.ADMIN_AUDIT_SET_LOGS_LOADING,
  isLoading
});

export const getAdminAuditLogs = (queryParams) => ({
  type: types.ADMIN_AUDIT_GET_LOGS,
  queryParams
});

export const setAdminAuditLogs = adminAuditLogs => ({
  type: types.ADMIN_AUDIT_SET_LOGS,
  adminAuditLogs
});

export const resetAdminAuditLogs = () => ({
  type: types.ADMIN_AUDIT_RESET_LOGS
});


// WEBPACK FOOTER //
// ./src/actions/admin/audit/index.js